module.exports = __webpack_public_path__ + "img/no-mission-data.2921ed76.svg";